const badge = {
  display: `inline-block`,
  borderRadius: `default`,
  textDecoration: `none`,
  fontWeight: `medium`,
  verticalAlign: `middle`,
  px: 3,
  py: 1,
  transition: ` all 250ms ease`
}

export default {
  badge
}
